document
	.querySelectorAll('.wp-block-realome-theme-extension-accordion-item')
	.forEach(function (element) {
		const accordionHeaderEl = element.querySelector(
			'.accordion-item-header a'
		);
		const accordionContentEl = element.querySelector(
			'.accordion-item-content'
		);

		accordionHeaderEl.addEventListener('click', function () {
			/* Toggle between adding and removing the "active" class,
		to highlight the button that controls the panel */
			accordionHeaderEl.classList.toggle('active');

			/* Toggle between hiding and showing the active panel */
			if (accordionContentEl.style.maxHeight) {
				//this is if the accordion is open
				accordionContentEl.style.maxHeight = null;
			} else {
				//if the accordion is currently closed
				accordionContentEl.style.maxHeight =
					accordionContentEl.scrollHeight + 'px';
			}
		});
	});
